import PopupLoading from '../../components/PopupLoading/PopupLoading';
import './Loading.css'; 

const Loading = () => {
  return <div className={`container page_loading no-animation`}>
    <div className="content">
      <PopupLoading />
    </div>
  </div>;
};

export default Loading;